export default {
    inject: ['taskContainer'],
    computed: {
        task () {
            return this.taskContainer.task
        }
    }
}
